module.exports = __webpack_public_path__ + "static/media/closeButton.061c0f13.svg";